<div class="spinner-container">
    <div class="text-center text-primary">
        <p><i [ngClass]="icons"></i></p>
        <p>{{text}}</p>
    </div> 
</div>